import { render, staticRenderFns } from "./RPBarChartCard.vue?vue&type=template&id=e895d0ba&"
import script from "./RPBarChartCard.vue?vue&type=script&lang=js&"
export * from "./RPBarChartCard.vue?vue&type=script&lang=js&"
import style0 from "./RPBarChartCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports